import React from 'react'
import translate from "../../../reusable/translate"
import moment from 'moment'

const OperationHeader = ({ operation, startingDate, endingDate, setCollapsed, editing }) => {
    return(
        <div className="flex-row space-between items-center margin-top">
            <h4 className="operation-box">
                {/*editing && moment(startingDate).format('DD.MM.YYYY')} - {editing && moment(endingDate).format('DD.MM.YYYY')*/} {operation.operationTitle_fi_FI}
            </h4>
            
            <button
                className="green-button"
                onClick={() => setCollapsed(false)}
                disabled={!startingDate || !endingDate}
            >
                {!editing && translate({ textKey: "sit.profile.reportOperation" })}

            {editing &&
                translate({
                    textKey:
                        "sit.profile.editReport"
            })}
            </button>
        </div>
    )
}

export default OperationHeader


// WEBPACK FOOTER //
// ./src/components/profile/reports/components/OperationHeader.jsx